import { Grid } from '@material-ui/core'
import { ImSad } from 'react-icons/im'
import { useHistory } from 'react-router-dom'
import Modal from 'shared/components/Modal'
import { colors } from 'shared/styles/colors'
import { ELockOCMessageTypes } from '../../utils/ELockOCMessage'
import { ContainerIcon, Message, StyleButton } from './styles'

const MESSAGE =
  'Infelizmente não foi possível gerar a ordem de carga. Isso pode ter acontecido por algumas razões, inclusive porque a cadência do lote foi preenchida.<br><br>Por favor, solicite um novo lote para o seu motorista.'

type TProps = {
  openModal?: boolean
  setAlertType?: (arg0: ELockOCMessageTypes) => void
}

const ModalSemCadencia: React.FC<TProps> = ({ openModal, setAlertType }) => {
  const history = useHistory()

  const handleCloseModal = () => {
    setAlertType(ELockOCMessageTypes.NENHUM)
    history.push('/lotes')
  }

  return (
    <>
      <Modal
        openModal={openModal}
        size={'small'}
        showCloseButton={true}
        onCloseModal={() => setAlertType(ELockOCMessageTypes.NENHUM)}
      >
        <Grid
          md={12}
          container
          spacing={4}
          justify="space-between"
          alignItems="center"
          style={{ textAlign: 'center', height: '100%' }}
        >
          <Grid container alignItems="center" justify="center" spacing={4}>
            <Grid item>
              <ContainerIcon>
                <ImSad size={90} color={colors.blue} />
              </ContainerIcon>
            </Grid>
          </Grid>

          <Grid container item>
            <Message
              dangerouslySetInnerHTML={{
                __html: `${MESSAGE}`,
              }}
            />
          </Grid>

          <Grid container alignItems="center" justify="center" item>
            <StyleButton color={colors.green} onClick={handleCloseModal}>
              Ver ofertas
            </StyleButton>
          </Grid>
        </Grid>
      </Modal>
    </>
  )
}

export default ModalSemCadencia
